module.exports = __webpack_public_path__ + "455e5866a49bac69fac52786805b346f.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/home.png
 ** module id = 1391
 ** module chunks = 0
 **/